import { render, staticRenderFns } from "./GroupBrowse.vue?vue&type=template&id=519865d2"
import script from "./GroupBrowse.vue?vue&type=script&lang=js"
export * from "./GroupBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports